<script type="text/jsx">
import mixin from '@/plans/mx/shopping-cart';
import EventCartMixin from '@/plans/EVENT_SAAS/cart';
import planCommonMixin from '@/plans/EVENT_SAAS_CORE/mixin';
import { getPlanUnitWithQuantity, planUnitMap } from '@/common/product-unit';

export default {
  mixins: [mixin, EventCartMixin, planCommonMixin],
  methods: {
    mx_license(num) {
      return (
        <div class="opc-cart-item__text">
          {num} {getPlanUnitWithQuantity(planUnitMap.license)}
        </div>
      );
    },
  },
};
</script>
